import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import SwipeScreens from './components/SwipeScreens'
import TableScreens from './components/TableScreens'
import behaviorList from './data/behavior_list.json'

export default function BehaviorTrigger() {
  // チェック済みアイテム配列
  const [checkedItems, setCheckedItems] = useState([])

  return (
    <>
      <SwipeScreens
        checkedItems={checkedItems}
        setCheckedItems={setCheckedItems}
      />
      <TableScreens
        checkedItems={checkedItems}
      />
    </>
  )
}

if (document.getElementById('behavior_trigger')) {
  ReactDOM.render(
    <BehaviorTrigger />,
    document.getElementById('behavior_trigger')
  )
}